import React, { Suspense, useEffect } from "react";
import { Routes, Route, Navigate, useNavigate, useLocation } from "react-router-dom";
import { Loader } from "../Components/Loader";
import useUser from "../Core/hook/useUser";
import { Privileges } from "../Core/Enum/enum";
import AccessDenied from "../Components/AccessDenied/AccessDenied";
import NotFound from "../Components/NotFound/NotFound";

import ClassBackupImportPage from "../Pages/ClassBackupImport";
import MessageTemplatesSettingsPage from "../Pages/Settings/MessageTemplates";
import CommunicationTemplatesPage from "../Pages/Settings/CommunicationTemplates";
import CampaignsListPage from "../Pages/Communication/Campaigns";
import CampaignWizardPage from "../Pages/Communication/Campaigns/Wizard";
import DirectMessagePage from "../Pages/Communication/DirectMessage";
import CampaignDetailPage from "../Pages/Communication/Campaigns/Detail";
import CommunicationHistoryPage from "../Pages/Communication/History";
import ClassMakeupImportPage from "../Pages/ClassMakeupImport";

import StudentSubjectsReportPage from "../Pages/AcademicReports/StudentSubjects";
import StaffCapacityReportPage from "../Pages/AcademicReports/StaffCapacity";
import StudentClassesReportPage from "../Pages/AcademicReports/StudentClasses";
import RegularClassScheduleReportPage from "../Pages/AcademicReports/RegularClassSchedule";
import StaffTimetableReportPage from "../Pages/AcademicReports/StaffTimetable";
import StudentTimetableReportPage from "../Pages/AcademicReports/StudentTimetable";

import Dashboard from "../Pages/Dashboard";
import StaffPortal from "../Pages/StaffPortal";
import MyStudents from "../Pages/StaffPortal/MyStudents";
import StudentView from "../Pages/StaffPortal/StudentView";
import StaffAssessments from "../Pages/StaffPortal/Assessments";
import StaffAssessmentCreate from "../Pages/StaffPortal/AssessmentCreate";
import StaffPortalCreateClass from "../Pages/StaffPortal/CreateClass";
import StaffAssessmentDetail from "../Pages/StaffPortal/AssessmentDetail";
import StaffReportCards from "../Pages/StaffPortal/ReportCards";
import StaffMessages from "../Pages/StaffPortal/Messages";
import StaffMessageTemplates from "../Pages/StaffPortal/MessageTemplates";
import StaffParentRequests from "../Pages/StaffPortal/ParentRequests";
import StaffPortalMyProfile from "../Pages/StaffPortal/MyProfile";
// StaffAssignments page removed from the Staff Portal — see the
// /staff-portal/assignments redirect below. The Pages/StaffPortal/
// Assignments.tsx component is left in the repo so admin/parent
// consumers of the Assignment feature keep compiling, but it is no
// longer imported by the router.
import Today from "../Pages/Today";

import Setting from "../Pages/Setting/index";
import SettingResetPassword from "../Pages/Setting/ResetPassword";

import CreateDepartment from "../Pages/Department/Create";
import ListDepartment from "../Pages/Department/List";

import CreateUser from "../Pages/User/create";
import ListUser from "../Pages/User/List";

import ListUserRole from "../Pages/UserRole/List";
import NewUserRolePage from "../Pages/UserRole/NewRole";
import ViewUserRolePage from "../Pages/UserRole/ViewRole";
import EditUserRolePage from "../Pages/UserRole/EditRole";

import CreateUserPrivilege from "../Pages/Privilege/Create";
import ListUserPrivilege from "../Pages/Privilege/List";

import ThemeColor from "../Pages/ThemeColor/Create";

import CreateDriver from "../Pages/Staff/Create";
import ListDriver from "../Pages/Staff/List";
import DriverHistory from "../Pages/Staff/View";
import EditStaffPage from "../Pages/Staff/Edit/EditPage";
import ChatPage from "../Pages/Chat";
import FinanceDashboard from "../Pages/Finance/Dashboard";
import FinanceTransactions from "../Pages/Finance/Transactions";
import FinanceExpenses from "../Pages/Finance/Expenses";
import FinanceInvoices from "../Pages/Finance/Invoices";
import FinanceInvoiceView from "../Pages/Finance/Invoices/View";
import ReconciliationQueue from "../Pages/Payment/Reconciliation";
import FinanceReports from "../Pages/Finance/Reports";
import ParentPortalLayout from "../Pages/ParentPortal2";
// ParentPortalManagement page removed from admin UI — legacy route
// `/parent-portal-management` now redirects to `/parents/list`. The
// page component file remains in the tree for possible future use
// but no route mounts it. Backend + Parent Portal (/parent-portal)
// for parent users are untouched.
import EmployeePdf from "../Pages/Staff/Print/employeePdf";
import AllEmployeepdf from "../Pages/Staff/Print/allEmployeepdf";
import EmployeePayrollpdf from "../Pages/Staff/staffPdf/index";

import ListPuchDetails from "../Pages/Punch/List";

import ListSchedule from "../Pages/Attendance/List";
import AdminCreateSchedule from "../Pages/Attendance/AdminEdit/AdminCreate";

import CreatePosition from "../Pages/Position/Create";
import ListPosition from "../Pages/Position/List";

import ListPayroll from "../Pages/Payroll/List";
import ConfirmPayroll from "../Pages/Payroll/ConfirmPayroll/index";
import ViewPayroll from "../Pages/Payroll/View";
import EditPayroll from "../Pages/Payroll/Edit";
import EmpReportPayroll from "../Pages/Payroll/FullView";

import ReScheduleList from "../Pages/ScheduleList/List";
import CreateScheduleList from "../Pages/ScheduleList/Create";

import EmployeeTimeScheduleList from "../Pages/EmployeeTimeSchedule/List";
import EmployeeWeeklyReport from "../Pages/EmployeeTimeSchedule/WeeklyReport";
// EmployeeTimeCalenderScheduleList retired 2026-08-25 — its route
// (/schedule/list/calender/one-day) now redirects to /class-schedule/list.
// The component file itself is left in the repo as a safe-removal
// candidate for a follow-up backend/frontend cleanup pass.
import RequestList from "../Pages/EmployeeTimeSchedule/Request/listEmailVeiw";
import RequestListViewList from "../Pages/EmployeeTimeSchedule/Request/viewlist";

import EmailSetting from "../Pages/EmailSetting/List";
import EmailSettingCreate from "../Pages/EmailSetting/Create";
import EmailTemplateCreate from "../Pages/EmailSetting/EmailTemplate/index";

import CreateStudent from "../Pages/Student/Create";
import ListStudent from "../Pages/Student/List";
import StudentHistory from "../Pages/Student/View";

import ParentList from "../Pages/Parent/List";
import ParentCreate from "../Pages/Parent/Create";
import ParentEdit from "../Pages/Parent/Edit";
import ParentDetail from "../Pages/Parent/Detail";

import LocationList from "../Pages/Locations/List/index";
import ClassList from "../Pages/Locations/List/calssList";

// All Classes page removed — /classes/list now redirects to Class Sessions
// (see ClassesListLegacyRedirect below).
import ClassesCreate from "../Pages/Classes/Create/index";
import ClassesEdit from "../Pages/Classes/Edit/index";
import ClassesEmpCreate from "../Pages/Classes/Create/empCreate";
import ClassesStudentCreate from "../Pages/Classes/Create/studentcreate";
import CheckClassesGetList from "../Pages/Classes/List/checkList";
import ClassesStaffCheckList from "../Pages/Classes/CheckStaff/ClassDetailPage";

import ClassScheduleList from "../Pages/ClassSchedule/List";
import PendingMakeupsQueue from "../Pages/ClassSchedule/PendingMakeups";
import ParentRequestsQueue from "../Pages/ClassSchedule/ParentRequests";
import ClassSchedulesPage from "../Pages/ClassSchedules";
import ClassScheduleCreate from "../Pages/ClassSchedule/Create";
import ClassScheduleEdit from "../Pages/ClassSchedule/Edit";
import ClassScheduleDetails from "../Pages/ClassScheduleDetails";
import ClassSessionDetails from "../Pages/ClassSessionDetails";
import ClassScheduleTemplateEdit from "../Pages/ClassScheduleTemplateEdit";
import ClassScheduleLegacyRedirect from "../Pages/ClassScheduleLegacyRedirect";
import AttendanceRecordList from "../Pages/AttendanceRecord/List";
import AttendanceReport from "../Pages/AttendanceReport";
import AttendanceSession from "../Pages/AttendanceSession/index";
import AttendanceLanding from "../Pages/Attendance/index";
import Assessments from "../Pages/Assessments/index";
import GradingRoster from "../Pages/Assessments/GradingRoster";
import AttendanceReportList from "../Pages/AttendanceRecord/Report";
import CourseList from "../Pages/Course/List";
import CourseCreate from "../Pages/Course/Create";
import CourseEdit from "../Pages/Course/Edit";
import CourseDetail from "../Pages/Course/Detail";
import InvoiceList from "../Pages/Invoice/List";
import InvoiceCreate from "../Pages/Invoice/Create";
import PaymentList from "../Pages/Payment/List";
import PaymentCreate from "../Pages/Payment/Create";
import MessageList from "../Pages/Message/List";
import MessageCreate from "../Pages/Message/Create";
import NotificationList from "../Pages/Notification/List";
import PermissionMatrix from "../Pages/Permission/Matrix";
import ActivityLogList from "../Pages/ActivityLog/List";
import StaffAvailabilityList from "../Pages/StaffAvailability/List";
import StudentNoteList from "../Pages/StudentNote/List";
import ReportDashboard from "../Pages/Report/Dashboard";
import StaffDashboard from "../Pages/StaffDashboard";
import StaffProfilePage from "../Pages/StaffProfile";
import ParentClassDetail from "../Pages/ClassDetail/ParentClassDetail";
import StaffLiveClass from "../Pages/ClassDetail/StaffLiveClass";
import ParentPortal from "../Pages/ParentPortal";

import AssessmentFocusAreaList from "../Pages/AssessmentFocusArea/List";
import ProgramLibraryList from "../Pages/ProgramLibrary/List";
import ProgramLibraryCreate from "../Pages/ProgramLibrary/Create";
import ProgramView from "../Pages/Program/View";
import SessionDataCreate from "../Pages/SessionData/Create";
import SessionDataList from "../Pages/SessionData/List";
import SessionDataView from "../Pages/SessionData/View";
import SessionDataReview from "../Pages/SessionData/Review";
import WorkflowSettings from "../Pages/Settings/Workflows";
import PromptHierarchiesList from "../Pages/Settings/PromptTemplates/List";
import TemplatesPage from "../Pages/ProgramLibrary/Templates";
import TreatmentAreasPage from "../Pages/Settings/TreatmentAreas";
import PromptHierarchyEditor from "../Pages/Settings/PromptTemplates/Editor";
import MasteryWorkflowsList from "../Pages/Settings/Workflows/List";
import MasteryWorkflowEditor from "../Pages/Settings/Workflows/Editor";
import MasteryApprovals from "../Pages/MasteryApprovals";
import ClientList from "../Pages/Client/List";
import Documentation from "../Pages/Documentation";
import HelpCenter from "../Pages/Help";
import HelpManage from "../Pages/Help/Manage";
import HelpEditor from "../Pages/Help/Manage/Editor";
import { EmailInbox, EmailPipeline, EmailHubDashboard, EmailHubSettings } from "../Pages/EmailHub";
import { LeadInquiries, LeadPipeline, LeadCalendar, LeadDashboard } from "../Pages/LeadSystem";
import LeadDetailPage from "../Pages/LeadSystem/LeadDetailPage";
import MyTasks from "../Pages/Tasks/MyTasks";

import { Box, CircularProgress } from "@mui/material";

/**
 * Preserves the query string when redirecting the retired /classes/list
 * (All Classes) to /class-schedule/list (Class Sessions). Keeps in-app
 * links AND bookmarked URLs with ?from_date=…&staff_id=… etc. working.
 */
const ClassesListLegacyRedirect: React.FC = () => {
  const { search } = useLocation();
  return <Navigate to={`/class-schedule/list${search}`} replace />;
};

// Batch 32 §1 — redirects old ABA Therapy paths into their /aba-therapy/*
// equivalents while preserving the child segment, query string, and hash.
const AbaTailRedirect: React.FC<{ from: string; to: string }> = ({ from, to }) => {
  const { pathname, search, hash } = useLocation();
  const tail = pathname.startsWith(from) ? pathname.slice(from.length) : "";
  return <Navigate to={`${to}${tail}${search}${hash}`} replace />;
};

// Batch 33 R — rewrites /base/edit/:id into the canonical /base/:id/edit.
const AbaEditFormRedirect: React.FC<{ base: string }> = ({ base }) => {
  const { pathname, search, hash } = useLocation();
  // pathname format: `${base}/edit/:id`
  const rest = pathname.slice(base.length + "/edit/".length);
  return <Navigate to={`${base}/${rest}/edit${search}${hash}`} replace />;
};

/**
 * Alias for `/class-sessions/:occurrenceId/attendance`.
 *
 * The staff-profile weekly-schedule popup "Mark Attendance" button was
 * built to link to /class-sessions/{occurrenceId}/attendance (see
 * `Staff/View/index.tsx` and `weeklyPopupActions.test.ts`), but the
 * SPA never registered that path — every other route under
 * /class-sessions is a static leaf (`/list`, `/:id/edit`). The result
 * was a client-side 404 for every Mark Attendance click.
 *
 * Fix: bridge to the real page, `/attendance-record/list`, and pass
 * the occurrence id via router state so the attendance page can
 * pre-select the session in the future. `return_url` is preserved as
 * a query param so the attendance page (or any Back button) can send
 * the user back to the staff calendar. */
const AttendanceRedirect: React.FC = () => {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const occurrenceId = window.location.pathname.split("/")[2];
  const returnUrl = params.get("return_url") || undefined;
  const nextQs = new URLSearchParams();
  if (occurrenceId) nextQs.set("occurrenceId", occurrenceId);
  if (returnUrl)    nextQs.set("return_url", returnUrl);
  const qs = nextQs.toString();
  return (
    <Navigate
      to={`/attendance-record/list${qs ? `?${qs}` : ""}`}
      replace
      state={{ occurrenceId: occurrenceId ? Number(occurrenceId) : undefined, returnUrl }}
    />
  );
};

/**
 * AppRoutes will load the app routes.
 * @returns
 */
const AppRoutes = () => {
  const { userHasRight, isLoading, isParentUser, isEmployeeUser, isSystemAdmin, isStaffRole } = useUser();
  // Portal separation, Phase 1. A non-admin employee assigned the
  // seeded "Staff" role must never render admin surfaces (dashboard,
  // Parents, Parent Portal Management, Finance) — even if the role
  // happens to still hold the underlying privilege. `<Navigate>`
  // pushes them to their own portal instead of silently swallowing
  // the click. Admins are unaffected.
  const StaffOrRedirect: React.FC<{ children: React.ReactNode }> = ({ children }) =>
    !isSystemAdmin && isStaffRole
      ? <Navigate to="/staff-portal" replace />
      : <>{children}</>;
  // Mirror guard for /staff-portal/* routes: a System Admin must NOT
  // render Staff Portal pages just because their session happens to
  // hold Assessment_View / Student_View / Message_View / etc. Bounce
  // them back to /dashboard so admin+staff surfaces stay separate
  // products. Parents also bounced to /parent-portal.
  const StaffPortalRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
    if (isParentUser) return <Navigate to="/parent-portal" replace />;
    if (isSystemAdmin) return <Navigate to="/dashboard" replace />;
    return <>{children}</>;
  };
  const navigate = useNavigate();

  if (isLoading) {
    return (
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="10vh"
      >
        <CircularProgress />
      </Box>
    );
  }

  // Parent users: parent portal layout with nested routes + chat
  if (isParentUser) {
    return (
      <Routes>
        <Route
          path="/parent-portal/*"
          element={
            <Suspense fallback={<Loader />}>
              <ParentPortalLayout />
            </Suspense>
          }
        />
        <Route
          path="/chat"
          element={
            <Suspense fallback={<Loader />}>
              <ChatPage />
            </Suspense>
          }
        />
        <Route
          path="/class-detail/:id"
          element={
            <Suspense fallback={<Loader />}>
              <ParentClassDetail />
            </Suspense>
          }
        />
        <Route
          path="*"
          element={
            <Suspense fallback={<Loader />}>
              <ParentPortalLayout />
            </Suspense>
          }
        />
      </Routes>
    );
  }

  // Employee users: full route set
  return (
    <Routes>
      <Route
        element={<Suspense fallback={<Loader />}></Suspense>}
        path="/fallback"
      />
      <Route
        element={
          <Suspense fallback={<Loader />}>
            <StaffOrRedirect>
              {userHasRight(Privileges.DashboardView) ? (
                <Dashboard />
              ) : (
                <Dashboard />
              )}
            </StaffOrRedirect>
          </Suspense>
        }
        path="/dashboard"
      />
      {/* Staff Portal — Phase 1 landing surface for the seeded Staff
          role. Any authenticated non-parent user can visit it, but
          the shell page itself uses staffId from useUser and hits an
          already-IDOR-guarded backend, so an employee without a
          staffId sees an empty state rather than another user's
          data. Route lives here so Login's redirect target resolves. */}
      <Route
        element={<Suspense fallback={<Loader />}><StaffPortalRoute><StaffPortal /></StaffPortalRoute></Suspense>}
        path="/staff-portal"
      />
      {/* Staff Portal Phase 3a — My Students + Staff-safe Student
          View. Both consume /api/staff-portal/* which enforces
          canAccessStudent server-side. Admins are bounced to
          /dashboard (they use the admin Students surface); parents
          go to /parent-portal. */}
      <Route
        element={<Suspense fallback={<Loader />}><StaffPortalRoute><MyStudents /></StaffPortalRoute></Suspense>}
        path="/staff-portal/students"
      />
      <Route
        element={<Suspense fallback={<Loader />}><StaffPortalRoute><StudentView /></StaffPortalRoute></Suspense>}
        path="/staff-portal/students/:studentId"
      />
      {/* Staff Portal Phase 3b — Assessments + Assignments. Backend
          scope enforcement means a foreign id renders the polite
          "You don't have access" state inside each page. */}
      <Route
        element={<Suspense fallback={<Loader />}><StaffPortalRoute><StaffAssessments /></StaffPortalRoute></Suspense>}
        path="/staff-portal/assessments"
      />
      <Route
        element={<Suspense fallback={<Loader />}><StaffPortalRoute><StaffAssessmentCreate /></StaffPortalRoute></Suspense>}
        path="/staff-portal/assessments/new"
      />
      {/* Staff-scoped Assessment detail. Route order matters — `/new`
          above must match first so `:id` never swallows the literal
          "new" segment. Backend `canAccessAssessment` gate returns 403
          on foreign rows; the detail component renders the polite
          "no access" state without leaking data. */}
      <Route
        element={<Suspense fallback={<Loader />}><StaffPortalRoute><StaffAssessmentDetail /></StaffPortalRoute></Suspense>}
        path="/staff-portal/assessments/:id"
      />
      {/* Staff Portal Report Cards — teacher-only academic report
          workspace scoped to students in the teacher's teaching scope.
          Backend enforces canAccessStudent regardless of what the
          student picker sends. */}
      <Route
        element={<Suspense fallback={<Loader />}><StaffPortalRoute><StaffReportCards /></StaffPortalRoute></Suspense>}
        path="/staff-portal/reports/report-cards"
      />
      {/* Staff Portal Create Class — auth-locked staff, subjects
          hydrated from the staff's own teaching assignments. Backend
          (classesAssignController::store) overwrites staff_id from
          auth for non-admin callers and validates every submitted
          grade-subject pair, so the UI is a convenience — the
          security contract is server-side. */}
      <Route
        element={<Suspense fallback={<Loader />}><StaffPortalRoute><StaffPortalCreateClass /></StaffPortalRoute></Suspense>}
        path="/staff-portal/classes/create"
      />
      {/* Staff Portal "My Assignments" removed from the sidebar. The
          route stays registered as a redirect so any bookmark or
          notification-deeplink lands on My Assessments (the single
          teacher-facing academic-work surface) instead of a NotFound
          page. `replace` keeps the browser history clean. */}
      <Route
        path="/staff-portal/assignments"
        element={<Navigate to="/staff-portal/assessments" replace />}
      />
      {/* Phase 3c — Staff-scoped Messages + Parent Requests. Backend
          enforces occurrence/student scope + permission split
          (ParentRequest_View / _Manage separate from ClassSchedule_Edit). */}
      <Route
        element={<Suspense fallback={<Loader />}><StaffPortalRoute><StaffMessages /></StaffPortalRoute></Suspense>}
        path="/staff-portal/messages"
      />
      <Route
        element={<Suspense fallback={<Loader />}><StaffPortalRoute><StaffMessageTemplates /></StaffPortalRoute></Suspense>}
        path="/staff-portal/message-templates"
      />
      <Route
        element={<Suspense fallback={<Loader />}><StaffPortalRoute><StaffParentRequests /></StaffPortalRoute></Suspense>}
        path="/staff-portal/parent-requests"
      />
      {/* Staff Portal — My Profile (view-only). Backend
          /api/staff-portal/profile is auth-derived (Auth::user()->staffId),
          so a foreign user hitting this URL sees their OWN profile, never
          another staff member's data. Wrapped in StaffPortalRoute so
          admins/parents bounce to their canonical home. */}
      <Route
        element={<Suspense fallback={<Loader />}><StaffPortalRoute><StaffPortalMyProfile /></StaffPortalRoute></Suspense>}
        path="/staff-portal/profile"
      />
      <Route
        path="/dashboard"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.DashboardView) ? (
              <Dashboard />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/today"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ClassScheduleView) ? <Today /> : <Dashboard />}
          </Suspense>
        }
      />
      <Route
        path="/setting"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.SettingView) ? <Setting /> : <Dashboard />}
          </Suspense>
        }
      />
      <Route
        path="/department/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.DepartmentView) ? (
              <ListDepartment />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/department/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.DepartmentView) ? (
              <CreateDepartment />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />

      <Route
        path="/user/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.UserView) ? <CreateUser /> : <Dashboard />}
          </Suspense>
        }
      />
      <Route
        path="/user/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.UserView) ? <ListUser /> : <Dashboard />}
          </Suspense>
        }
      />
      <Route
        path="/user/role/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.UserView) ? (
              <ListUserRole />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/user/role/new"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.UserView) ? (
              <NewUserRolePage />
            ) : (
              <AccessDenied />
            )}
          </Suspense>
        }
      />
      <Route
        path="/user/role/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.UserView) ? (
              <ViewUserRolePage />
            ) : (
              <AccessDenied />
            )}
          </Suspense>
        }
      />
      <Route
        path="/user/role/:id/edit"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.UserView) ? (
              <EditUserRolePage />
            ) : (
              <AccessDenied />
            )}
          </Suspense>
        }
      />
      <Route
        path="/user/privilege/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.UserView) ? (
              <CreateUserPrivilege />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/user/privilege/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.UserView) ? (
              <ListUserPrivilege />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />

      {/* Branch module retired (Phase 4) — Campus Location replaces it.
          Restaurant page components remain in src/Pages/Restaurant (orphaned). */}

      <Route
        path="/theme-color"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ThemeView) ? (
              <ThemeColor />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/team/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.StaffView) ? (
              <CreateDriver />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/team/edit/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.StaffView) ? (
              <EditStaffPage />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/team/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.StaffView) ? (
              <ListDriver />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/team-history/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.StaffView) ? (
              <DriverHistory />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/punch/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.PunchDetailsView) ? (
              <ListPuchDetails />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/schedule/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ScheduleView) ? (
              <ListSchedule />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/position/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.PositionView) ? (
              <ListPosition />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/position/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.PositionView) ? (
              <CreatePosition />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/payroll/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.PayrollView) ? (
              <ListPayroll />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/payroll/generate"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.GeneratePayroll) ? (
              <ConfirmPayroll />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/team/schedule/pdf/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.StaffView) ? (
              <EmployeePdf />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/all/team/schedule/pdf/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.StaffView) ? (
              <AllEmployeepdf />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />

      <Route
        path="/re-Schedule/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ScheduleView) ? (
              <ReScheduleList />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/re-Schedule/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ScheduleEdit) ? (
              <CreateScheduleList />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/schedule/list/one-day"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ScheduleView) ? (
              <EmployeeTimeScheduleList />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      {/* Legacy "Schedule & Reschedule List" (EmployeeTimeCalenderScheduleList)
          retired 2026-08-25. It duplicated functionality now owned by
          ACADEMICS → Classes → Class Sessions (/class-schedule/list),
          and the menu entry that led to it was removed. Any surviving
          bookmark or deep-link falls through to the modern Class
          Sessions workspace, where the destination route's own
          ClassScheduleView guard applies — permissions are unchanged. */}
      <Route
        path="/schedule/list/calender/one-day"
        element={<Navigate to="/class-schedule/list" replace />}
      />
      <Route
        path="/payroll/list/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.PayrollView) ? (
              <ViewPayroll />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/attendance/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ScheduleEdit) ? (
              <AdminCreateSchedule />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/payroll/list/edit/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.PayrollView) ? (
              <EditPayroll />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/payroll/list/emp/report/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.PayrollView) ? (
              <EmpReportPayroll />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/emp/report/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.PayrollView) ? (
              <EmployeePayrollpdf />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/attendance/weekly/report"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ScheduleView) ? (
              <EmployeeWeeklyReport />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/email/setting/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.EmailView) ? (
              <EmailSetting />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/email/setting/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.EmailView) ? (
              <EmailSettingCreate />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/email/template/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.EmailView) ? (
              <EmailTemplateCreate />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/request/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ScheduleView) ? (
              <RequestList />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/request/view/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ScheduleView) ? (
              <RequestListViewList />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/student/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.StudentView) ? (
              <CreateStudent />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/student/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.StudentView) ? (
              <ListStudent />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/parents/list"
        element={
          <Suspense fallback={<Loader />}>
            <StaffOrRedirect>
              {userHasRight(Privileges.ParentView) ? <ParentList /> : <Dashboard />}
            </StaffOrRedirect>
          </Suspense>
        }
      />
      <Route
        path="/parents/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ParentCreate) ? <ParentCreate /> : <Dashboard />}
          </Suspense>
        }
      />
      <Route
        path="/parents/edit/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ParentEdit) ? <ParentEdit /> : <Dashboard />}
          </Suspense>
        }
      />
      <Route
        path="/parents/view/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ParentView) ? <ParentDetail /> : <Dashboard />}
          </Suspense>
        }
      />
      <Route
        path="/student-history/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.StudentView) ? (
              <StudentHistory />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/location/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.StudentView) ? (
              <LocationList />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/class/subject/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.StudentView) ? (
              <ClassList />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/assessment/focus-areas/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.SettingView) ? (
              <AssessmentFocusAreaList />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      {/* Legacy /classes/list — the "All Classes" calendar was consolidated
          into Class Sessions (`/class-schedule/list`) so we no longer render
          it. Redirect (not 404) preserves any existing bookmarks and the
          full query string (from_date, to_date, staff_id, student_id,
          location_id, mode, status, return_url, etc). */}
      <Route
        path="/classes/list"
        element={<ClassesListLegacyRedirect />}
      />
      {/* Edit Class page — uses the shared ClassForm so the layout matches
          Create Class. Superseded the modal-dialog Edit; callers navigate
          here with `?return_url=` to preserve list filters. */}
      <Route
        path="/classes/:id/edit"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ClassesEdit) ? (
              <ClassesEdit />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/assign/classes/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ClassesView) ? (
              <ClassesCreate />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/assign/classes/create/emp/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ClassesView) ? (
              <ClassesEmpCreate />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/assign/classes/create/student/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ClassesView) ? (
              <ClassesStudentCreate />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/check/classes/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ClassesView) ? (
              <CheckClassesGetList />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/check-staff/classes/list/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ClassesView) ? (
              <ClassesStaffCheckList />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/setting/reset-password"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.SettingView) ? (
              <SettingResetPassword />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      {/* Staff Profile — accessible by all authenticated users */}
      <Route
        path="/my-profile"
        element={
          <Suspense fallback={<Loader />}>
            <StaffProfilePage />
          </Suspense>
        }
      />
      {/* Class Detail Pages */}
      <Route
        path="/class-detail/:id"
        element={
          <Suspense fallback={<Loader />}>
            <ParentClassDetail />
          </Suspense>
        }
      />
      <Route
        path="/class-live/:id"
        element={
          <Suspense fallback={<Loader />}>
            <StaffLiveClass />
          </Suspense>
        }
      />
      {/* Class Sessions — dated occurrences (formerly "Class Schedule"). */}
      {/* Class Schedules — recurring PATTERN list (bulk future management). */}
      <Route
        path="/class-schedules"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ClassScheduleView) ? (
              <ClassSchedulesPage />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/class-schedules/pending-makeups"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ClassScheduleView) ? (
              <PendingMakeupsQueue />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/classes/parent-requests"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ClassScheduleView) ? (
              <ParentRequestsQueue />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/class-schedule/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ClassScheduleView) ? (
              <ClassScheduleList />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/class-schedule/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ClassScheduleView) ? (
              <ClassScheduleCreate />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      {/* Legacy edit URL — resolves the id and forwards to the correct edit view. */}
      <Route
        path="/class-schedule/edit/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ClassScheduleEdit) ? (
              <ClassScheduleLegacyRedirect />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      {/* Template (assign_classes) details + edit — anchored on classId, not occurrence id. */}
      <Route
        path="/class-schedules/:classId"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ClassScheduleView) ? (
              <ClassScheduleDetails />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/class-schedules/:classId/edit"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ClassScheduleEdit) ? (
              <ClassScheduleTemplateEdit />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      {/* /class-sessions aliases for the dated occurrence pages. */}
      <Route
        path="/class-sessions/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ClassScheduleView) ? (
              <ClassScheduleList />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      {/* Class Session Details — the canonical read-first "full
          details" page for one occurrence. Kept deliberately
          separate from /attendance (entry workspace) and from
          /attendance/report (submitted history). Uses occurrence id;
          the underlying detail endpoint already IDOR-guards. */}
      <Route
        path="/class-sessions/:occurrenceId/details"
        element={
          <Suspense fallback={<Loader />}>
            {isParentUser ? <Navigate to="/parent-portal" replace /> : <ClassSessionDetails />}
          </Suspense>
        }
      />
      <Route
        path="/class-sessions/:occurrenceId/edit"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ClassScheduleEdit) ? (
              <ClassScheduleEdit />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      {/* Class Calendar consolidated into /class-schedule/list — redirect old links/bookmarks. */}
      <Route
        path="/class-calendar"
        element={<Navigate to="/class-schedule/list" replace />}
      />
      {/* Assessments — student mark records with report-card comments. */}
      <Route
        path="/assessments"
        element={
          <Suspense fallback={<Loader />}>
            <Assessments />
          </Suspense>
        }
      />
      {/* Grading roster — full page for bulk-entering marks + comments
          on a group-linked assessment. Backend enforces Assessment_Grade /
          Assessment_Publish; the page also gates edit/publish visually. */}
      <Route
        path="/assessments/groups/:id/grade"
        element={
          <Suspense fallback={<Loader />}>
            <GradingRoster />
          </Suspense>
        }
      />
      {/* Attendance landing — sidebar "Attendance" nav lands here to pick a session. */}
      <Route
        path="/attendance"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.AttendanceView) ? (
              <AttendanceLanding />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      {/* Attendance Session — live "Mark Attendance" page (per-subject roster). */}
      <Route
        path="/class-sessions/:id/attendance"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.AttendanceView) ? (
              <AttendanceSession />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      {/* Per-session Attendance Report — analytics page rendered when
          a staff clicks "📊 View Report" on a past session. */}
      <Route
        path="/attendance/report/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.AttendanceView) ? (
              <AttendanceReport />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />

      {/* Attendance */}
      <Route
        path="/attendance-record/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.AttendanceView) ? (
              <AttendanceRecordList />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/attendance-record/report"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.AttendanceView) ? (
              <AttendanceReportList />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      {/* Courses (LMS) */}
      <Route
        path="/course/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.CourseView) ? (
              <CourseList />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/course/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.CourseView) ? (
              <CourseCreate />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/course/edit/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.CourseView) ? (
              <CourseEdit />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/course/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.CourseView) ? (
              <CourseDetail />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      {/* Invoices */}
      <Route
        path="/invoice/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.InvoiceView) ? (
              <InvoiceList />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/invoice/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.InvoiceView) ? (
              <InvoiceCreate />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      {/* Payments */}
      <Route
        path="/payment/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.PaymentView) ? (
              <PaymentList />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/payment/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.PaymentView) ? (
              <PaymentCreate />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      {/* Messages */}
      <Route
        path="/message/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.MessageView) ? (
              <MessageList />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      <Route
        path="/message/create"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.MessageView) ? (
              <MessageCreate />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      {/* Notifications */}
      <Route
        path="/notification/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.NotificationView) ? (
              <NotificationList />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      {/* Permission Matrix */}
      <Route
        path="/permission/matrix"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.PermissionView) ? (
              <PermissionMatrix />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      {/* Activity Log */}
      <Route
        path="/activity-log/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ActivityLogView) ? (
              <ActivityLogList />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      {/* Staff Availability */}
      <Route
        path="/staff-availability/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.StaffAvailabilityView) ? (
              <StaffAvailabilityList />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      {/* Student Notes */}
      <Route
        path="/student-note/:id"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.StudentNoteView) ? (
              <StudentNoteList />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      {/* Reports */}
      <Route
        path="/report/dashboard"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ReportView) ? (
              <ReportDashboard />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      {/* Staff Dashboard */}
      <Route
        path="/staff-dashboard"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.StaffView) ? (
              <StaffDashboard />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      {/* Finance — admin surface. Every finance route wraps in
          <StaffOrRedirect> so a staff-role user hitting the URL
          directly bounces to /staff-portal instead of momentarily
          rendering the admin finance dashboard. The privilege
          fallback (→ <Dashboard/>) is preserved for admins who
          happen to lack the specific finance privilege. */}
      <Route path="/finance" element={<Suspense fallback={<Loader />}><StaffOrRedirect>{userHasRight(Privileges.PaymentView) ? <FinanceDashboard /> : <Dashboard />}</StaffOrRedirect></Suspense>} />
      <Route path="/finance/transactions" element={<Suspense fallback={<Loader />}><StaffOrRedirect>{userHasRight(Privileges.PaymentView) ? <FinanceTransactions /> : <Dashboard />}</StaffOrRedirect></Suspense>} />
      <Route path="/finance/expenses" element={<Suspense fallback={<Loader />}><StaffOrRedirect>{userHasRight(Privileges.PaymentView) ? <FinanceExpenses /> : <Dashboard />}</StaffOrRedirect></Suspense>} />
      <Route path="/finance/invoices" element={<Suspense fallback={<Loader />}><StaffOrRedirect>{userHasRight(Privileges.InvoiceView) ? <FinanceInvoices /> : <Dashboard />}</StaffOrRedirect></Suspense>} />
      <Route path="/finance/invoices/:id" element={<Suspense fallback={<Loader />}><StaffOrRedirect>{userHasRight(Privileges.InvoiceView) ? <FinanceInvoiceView /> : <Dashboard />}</StaffOrRedirect></Suspense>} />
      <Route path="/finance/reports" element={<Suspense fallback={<Loader />}><StaffOrRedirect>{userHasRight(Privileges.PaymentView) ? <FinanceReports /> : <Dashboard />}</StaffOrRedirect></Suspense>} />
      <Route path="/finance/payments/reconciliation" element={<Suspense fallback={<Loader />}><StaffOrRedirect>{userHasRight(Privileges.PaymentView) ? <ReconciliationQueue /> : <Dashboard />}</StaffOrRedirect></Suspense>} />

      {/* Chat / Messages */}
      <Route
        path="/chat"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.MessageView) ? (
              <ChatPage />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />

      {/* Parent Portal Management page was removed from the admin UI
         per client request. All parent account + portal-access
         controls (Enable / Suspend / Reset Password / Send Login
         Instructions / linked children) live inside the Parents page
         at /parents/list. Legacy bookmarks and any admin who lands
         on `/parent-portal` (which for parent users renders the
         actual portal) are redirected to the Parents page instead
         of a dead route. Backend endpoints + `Parent_Portal_View`
         permission are untouched. */}
      <Route
        path="/parent-portal-management"
        element={<Navigate to="/parents/list" replace />}
      />
      <Route
        path="/parent-portal/*"
        element={
          userHasRight(Privileges.ParentPortalView)
            ? <Navigate to="/parents/list" replace />
            : <Dashboard />
        }
      />
      {/* ── ABA Therapy (Batch 32 §1) ─────────────────────────────────────
         Every page in this module now lives under a single /aba-therapy/*
         root so the sidebar, breadcrumbs, and URL agree. Old paths keep
         working as tail-preserving redirects — see AbaTailRedirect at the
         end of this block. */}
      <Route
        path="/aba-therapy/programs"
        element={<Suspense fallback={<Loader />}>{userHasRight(Privileges.ProgramLibraryView) ? <ProgramLibraryList /> : <Dashboard />}</Suspense>}
      />
      {/* Batch 33 R — canonical forms are /new (create) and /:id/edit (edit).
         The alternate forms redirect to the canonical to keep old bookmarks
         and any internal navigate() calls working during the sweep. */}
      <Route
        path="/aba-therapy/programs/new"
        element={<Suspense fallback={<Loader />}>{userHasRight(Privileges.ProgramView) ? <ProgramLibraryCreate /> : <Dashboard />}</Suspense>}
      />
      <Route path="/aba-therapy/programs/create" element={<Navigate to="/aba-therapy/programs/new" replace />} />
      <Route
        path="/aba-therapy/programs/:id/edit"
        element={<Suspense fallback={<Loader />}>{userHasRight(Privileges.ProgramView) ? <ProgramLibraryCreate /> : <Dashboard />}</Suspense>}
      />
      <Route path="/aba-therapy/programs/edit/:id" element={<AbaEditFormRedirect base="/aba-therapy/programs" />} />
      <Route
        path="/aba-therapy/programs/:id"
        element={<Suspense fallback={<Loader />}>{userHasRight(Privileges.ProgramView) ? <ProgramView /> : <Dashboard />}</Suspense>}
      />
      <Route
        path="/aba-therapy/sessions"
        element={<Suspense fallback={<Loader />}>{userHasRight(Privileges.SessionDataView) ? <SessionDataList /> : <Dashboard />}</Suspense>}
      />
      <Route
        path="/aba-therapy/sessions/new"
        element={<Suspense fallback={<Loader />}>{userHasRight(Privileges.SessionDataView) ? <SessionDataCreate /> : <Dashboard />}</Suspense>}
      />
      <Route path="/aba-therapy/sessions/create" element={<Navigate to="/aba-therapy/sessions/new" replace />} />
      <Route
        path="/aba-therapy/sessions/:id"
        element={<Suspense fallback={<Loader />}>{userHasRight(Privileges.SessionDataView) ? <SessionDataView /> : <Dashboard />}</Suspense>}
      />
      <Route
        path="/aba-therapy/sessions/:id/edit"
        element={<Suspense fallback={<Loader />}>{userHasRight(Privileges.SessionDataView) ? <SessionDataCreate /> : <Dashboard />}</Suspense>}
      />
      <Route
        path="/aba-therapy/sessions/:id/review"
        element={<Suspense fallback={<Loader />}>{userHasRight(Privileges.SessionDataView) ? <SessionDataReview /> : <Dashboard />}</Suspense>}
      />
      {/* Batch 61 §1 — Settings sub-group. Workflows and Prompt Levels
         moved from /aba-therapy/{workflows,prompt-hierarchies} to
         /aba-therapy/settings/{workflows,prompt-levels}. Old paths
         redirect below via AbaTailRedirect, preserving tail + query
         + hash so bookmarks and deep links keep working. */}
      <Route
        path="/aba-therapy/mastery-approvals"
        element={<Suspense fallback={<Loader />}>{userHasRight(Privileges.MasteryView) || userHasRight(Privileges.WorkflowView) ? <MasteryApprovals /> : <Dashboard />}</Suspense>}
      />
      <Route
        path="/aba-therapy/settings/workflows"
        element={<Suspense fallback={<Loader />}>{userHasRight(Privileges.WorkflowView) ? <MasteryWorkflowsList /> : <Dashboard />}</Suspense>}
      />
      <Route
        path="/aba-therapy/settings/workflows/new"
        element={<Suspense fallback={<Loader />}>{userHasRight(Privileges.WorkflowView) ? <MasteryWorkflowEditor mode="create" /> : <Dashboard />}</Suspense>}
      />
      <Route path="/aba-therapy/settings/workflows/create" element={<Navigate to="/aba-therapy/settings/workflows/new" replace />} />
      <Route
        path="/aba-therapy/settings/workflows/:id"
        element={<Suspense fallback={<Loader />}>{userHasRight(Privileges.WorkflowView) ? <MasteryWorkflowEditor mode="view" /> : <Dashboard />}</Suspense>}
      />
      <Route
        path="/aba-therapy/settings/workflows/:id/edit"
        element={<Suspense fallback={<Loader />}>{userHasRight(Privileges.WorkflowView) ? <MasteryWorkflowEditor mode="edit" /> : <Dashboard />}</Suspense>}
      />
      <Route
        path="/aba-therapy/settings/prompt-levels"
        element={<Suspense fallback={<Loader />}>{userHasRight(Privileges.PromptTemplateView) ? <PromptHierarchiesList /> : <Dashboard />}</Suspense>}
      />
      <Route
        path="/aba-therapy/settings/prompt-levels/new"
        element={<Suspense fallback={<Loader />}>{userHasRight(Privileges.PromptTemplateView) ? <PromptHierarchyEditor mode="create" /> : <Dashboard />}</Suspense>}
      />
      <Route path="/aba-therapy/settings/prompt-levels/create" element={<Navigate to="/aba-therapy/settings/prompt-levels/new" replace />} />
      <Route
        path="/aba-therapy/settings/prompt-levels/:id"
        element={<Suspense fallback={<Loader />}>{userHasRight(Privileges.PromptTemplateView) ? <PromptHierarchyEditor mode="view" /> : <Dashboard />}</Suspense>}
      />
      <Route
        path="/aba-therapy/settings/prompt-levels/:id/edit"
        element={<Suspense fallback={<Loader />}>{userHasRight(Privileges.PromptTemplateView) ? <PromptHierarchyEditor mode="edit" /> : <Dashboard />}</Suspense>}
      />

      {/* Batch 61 §5 — Program Templates settings page (promotion of the
         former TemplatesDrawer). */}
      <Route
        path="/aba-therapy/settings/templates"
        element={<Suspense fallback={<Loader />}>{userHasRight(Privileges.ProgramLibraryView) ? <TemplatesPage /> : <Dashboard />}</Suspense>}
      />
      {/* Batch 61 §2 — Treatment Areas settings page. */}
      <Route
        path="/aba-therapy/settings/treatment-areas"
        element={<Suspense fallback={<Loader />}>{userHasRight(Privileges.ProgramLibraryView) ? <TreatmentAreasPage /> : <Dashboard />}</Suspense>}
      />

      {/* Batch 61 §1 — redirects for the moved paths. Tail-preserving so
         `/aba-therapy/workflows/17/edit` still lands on the editor. */}
      <Route path="/aba-therapy/workflows"          element={<AbaTailRedirect from="/aba-therapy/workflows"          to="/aba-therapy/settings/workflows" />} />
      <Route path="/aba-therapy/workflows/*"        element={<AbaTailRedirect from="/aba-therapy/workflows"          to="/aba-therapy/settings/workflows" />} />
      <Route path="/aba-therapy/prompt-hierarchies" element={<AbaTailRedirect from="/aba-therapy/prompt-hierarchies" to="/aba-therapy/settings/prompt-levels" />} />
      <Route path="/aba-therapy/prompt-hierarchies/*" element={<AbaTailRedirect from="/aba-therapy/prompt-hierarchies" to="/aba-therapy/settings/prompt-levels" />} />

      {/* Legacy paths — tail-preserving redirects into /aba-therapy/* so
         existing bookmarks keep working. Query string and hash preserved
         by AbaTailRedirect. Order matters: /program/view/* must precede
         any prefix that could shadow it (there isn't one, but noted). */}
      <Route path="/program-library" element={<AbaTailRedirect from="/program-library" to="/aba-therapy/programs" />} />
      <Route path="/program-library/*" element={<AbaTailRedirect from="/program-library" to="/aba-therapy/programs" />} />
      <Route path="/program/view/*" element={<AbaTailRedirect from="/program/view" to="/aba-therapy/programs" />} />
      <Route path="/session-data" element={<AbaTailRedirect from="/session-data" to="/aba-therapy/sessions" />} />
      <Route path="/session-data/*" element={<AbaTailRedirect from="/session-data" to="/aba-therapy/sessions" />} />
      {/* Batch 61 §1 — legacy /settings/* now targets the new
         /aba-therapy/settings/* home, one hop rather than two. */}
      <Route path="/settings/workflows" element={<AbaTailRedirect from="/settings/workflows" to="/aba-therapy/settings/workflows" />} />
      <Route path="/settings/workflows/*" element={<AbaTailRedirect from="/settings/workflows" to="/aba-therapy/settings/workflows" />} />
      <Route path="/settings/prompt-templates" element={<AbaTailRedirect from="/settings/prompt-templates" to="/aba-therapy/settings/prompt-levels" />} />
      <Route path="/settings/prompt-templates/*" element={<AbaTailRedirect from="/settings/prompt-templates" to="/aba-therapy/settings/prompt-levels" />} />
      <Route
        path="/settings/workflows-legacy"
        element={<Suspense fallback={<Loader />}>{userHasRight(Privileges.WorkflowView) ? <WorkflowSettings /> : <Dashboard />}</Suspense>}
      />
      {/* Hi Rasmus - Clients */}
      <Route
        path="/client/list"
        element={
          <Suspense fallback={<Loader />}>
            {userHasRight(Privileges.ProgramView) ? (
              <ClientList />
            ) : (
              <Dashboard />
            )}
          </Suspense>
        }
      />
      {/* Documentation — accessible to all authenticated users */}
      <Route
        path="/documentation"
        element={
          <Suspense fallback={<Loader />}>
            <Documentation />
          </Suspense>
        }
      />
      {/* Help Center — dynamic documentation, admin-manageable */}
      <Route path="/help-center" element={<Suspense fallback={<Loader />}><HelpCenter /></Suspense>} />
      <Route path="/help-center/manage" element={<Suspense fallback={<Loader />}><HelpManage /></Suspense>} />
      <Route path="/help-center/manage/new" element={<Suspense fallback={<Loader />}><HelpEditor /></Suspense>} />
      <Route path="/help-center/manage/:id" element={<Suspense fallback={<Loader />}><HelpEditor /></Suspense>} />
      <Route path="/help-center/:slug" element={<Suspense fallback={<Loader />}><HelpCenter /></Suspense>} />
      {/* Email Hub — Microsoft 365 inbox, sales pipeline, dashboard.
          No dedicated privilege yet; visible to authenticated employees. */}
      <Route
        path="/email-hub"
        element={
          <Suspense fallback={<Loader />}>
            <EmailInbox />
          </Suspense>
        }
      />
      <Route
        path="/email-hub/pipeline"
        element={
          <Suspense fallback={<Loader />}>
            <EmailPipeline />
          </Suspense>
        }
      />
      <Route
        path="/email-hub/dashboard"
        element={
          <Suspense fallback={<Loader />}>
            <EmailHubDashboard />
          </Suspense>
        }
      />
      {/* Email Hub settings */}
      <Route path="/email-hub/settings" element={<Suspense fallback={<Loader />}><EmailHubSettings /></Suspense>} />

      {/* Admin: legacy class import tool — page self-gates by privilege via sidebar,
          plus every backend route enforces ClassBackupImport_View / _Execute. */}
      <Route path="/settings/class-backup-import" element={
        <Suspense fallback={<Loader />}>
          {userHasRight(Privileges.ClassBackupImportView) ? <ClassBackupImportPage /> : <AccessDenied />}
        </Suspense>
      } />
      {/* Makeup Classes Import — shares the same permission module as the regular
          backup importer; the backend routes enforce it independently. */}
      <Route path="/settings/class-backup-import/makeups" element={
        <Suspense fallback={<Loader />}>
          {userHasRight(Privileges.ClassBackupImportView) ? <ClassMakeupImportPage /> : <AccessDenied />}
        </Suspense>
      } />

      {/* Attendance Messaging Phase 2 — tenant/global message templates.
          System_Admin only. Backend routes independently enforce the
          same gate on every write; this route just hides the surface
          from non-admins. */}
      <Route path="/settings/message-templates" element={
        <Suspense fallback={<Loader />}>
          {isSystemAdmin ? <MessageTemplatesSettingsPage /> : <AccessDenied />}
        </Suspense>
      } />

      {/* Communication Templates workspace (Phase 1) — unified Email +
          SMS templates backed by crm_email_templates. Gated by
          SettingView, same as the sibling Message Templates screen. */}
      <Route path="/settings/communication-templates" element={
        <Suspense fallback={<Loader />}>
          {userHasRight(Privileges.SettingView) ? <CommunicationTemplatesPage /> : <AccessDenied />}
        </Suspense>
      } />

      {/* Pass E §9 — primary Templates destination under Communication.
          The Settings alias above stays live for existing bookmarks. */}
      <Route path="/communication/templates" element={
        <Suspense fallback={<Loader />}>
          {userHasRight(Privileges.SettingView) ? <CommunicationTemplatesPage /> : <AccessDenied />}
        </Suspense>
      } />

      {/* Communication → Newsletters & Campaigns workspace (Pass C). */}
      <Route path="/communication/newsletters" element={
        <Suspense fallback={<Loader />}>
          {userHasRight(Privileges.CampaignView) ? <CampaignsListPage /> : <AccessDenied />}
        </Suspense>
      } />
      <Route path="/communication/newsletters/create" element={
        <Suspense fallback={<Loader />}>
          {userHasRight(Privileges.CampaignCreate) ? <CampaignWizardPage /> : <AccessDenied />}
        </Suspense>
      } />
      <Route path="/communication/newsletters/:id/edit" element={
        <Suspense fallback={<Loader />}>
          {userHasRight(Privileges.CampaignCreate) ? <CampaignWizardPage /> : <AccessDenied />}
        </Suspense>
      } />
      <Route path="/communication/newsletters/:id" element={
        <Suspense fallback={<Loader />}>
          {userHasRight(Privileges.CampaignView) ? <CampaignDetailPage /> : <AccessDenied />}
        </Suspense>
      } />

      {/* Central Communication History (Pass D). Gated by
          CommunicationHistory_View; Super Admin bypass follows the
          project's existing rule. */}
      <Route path="/communication/history" element={
        <Suspense fallback={<Loader />}>
          {(userHasRight(Privileges.CommunicationHistoryView) || isSystemAdmin)
            ? <CommunicationHistoryPage /> : <AccessDenied />}
        </Suspense>
      } />

      {/* Direct Message composer (Pass F2). Distinct from the legacy
          /message/list in-app chat surface — this sends real email /
          SMS via Microsoft Graph + INTALK. */}
      <Route path="/communication/direct-message" element={
        <Suspense fallback={<Loader />}>
          {(userHasRight(Privileges.DirectCommunicationView) || isSystemAdmin)
            ? <DirectMessagePage /> : <AccessDenied />}
        </Suspense>
      } />

      {/* Academic Reports — one route per report; each self-gates */}
      <Route path="/reports/student-subjects" element={
        <Suspense fallback={<Loader />}>
          {userHasRight(Privileges.AcademicReportStudentSubjects) ? <StudentSubjectsReportPage /> : <AccessDenied />}
        </Suspense>
      } />
      <Route path="/reports/staff-capacity" element={
        <Suspense fallback={<Loader />}>
          {userHasRight(Privileges.AcademicReportStaffCapacity) ? <StaffCapacityReportPage /> : <AccessDenied />}
        </Suspense>
      } />
      <Route path="/reports/student-classes" element={
        <Suspense fallback={<Loader />}>
          {userHasRight(Privileges.AcademicReportStudentClasses) ? <StudentClassesReportPage /> : <AccessDenied />}
        </Suspense>
      } />
      <Route path="/reports/staff-timetable" element={
        <Suspense fallback={<Loader />}>
          {userHasRight(Privileges.AcademicReportStaffTimetable) ? <StaffTimetableReportPage /> : <AccessDenied />}
        </Suspense>
      } />
      <Route path="/reports/student-timetable" element={
        <Suspense fallback={<Loader />}>
          {userHasRight(Privileges.AcademicReportStudentTimetable) ? <StudentTimetableReportPage /> : <AccessDenied />}
        </Suspense>
      } />
      <Route path="/reports/regular-class-schedule" element={
        <Suspense fallback={<Loader />}>
          {userHasRight(Privileges.AcademicReportStudentClasses) ? <RegularClassScheduleReportPage /> : <AccessDenied />}
        </Suspense>
      } />

      {/* Lead System — pages self-gate via usePermission (admins see all).
          The dynamic /leads/:id is declared AFTER the static /leads/* paths. */}
      <Route path="/leads/inquiries" element={<Suspense fallback={<Loader />}><LeadInquiries /></Suspense>} />
      <Route path="/leads/pipeline" element={<Suspense fallback={<Loader />}><LeadPipeline /></Suspense>} />
      <Route path="/leads/calendar" element={<Suspense fallback={<Loader />}><LeadCalendar /></Suspense>} />
      <Route path="/leads/dashboard" element={<Suspense fallback={<Loader />}><LeadDashboard /></Suspense>} />
      <Route path="/leads/:id" element={<Suspense fallback={<Loader />}><LeadDetailPage /></Suspense>} />

      {/* My Tasks (lead follow-up tasks) */}
      <Route path="/tasks" element={<Suspense fallback={<Loader />}><MyTasks /></Suspense>} />

      <Route element={<NotFound />} path="*" />
      <Route element={<AccessDenied />} path="/access-denied" />
      <Route element={<Navigate replace to="/dashboard" />} path="" />
    </Routes>
  );
};

export default AppRoutes;
